import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 8 8"
  }, props),
  /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 4, fill: "currentColor" })
);
var SvgCircleFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CircleFilled_default = SvgCircleFilled;

export { CircleFilled_default as default };
